<template>
  <v-container fluid grid-list-md text-xs-center style="min-height: 93.4vh">
    <v-layout row wrap>
      <v-toolbar class="main-tool-bar" scroll-target="#scrolling-home">
        <v-layout
          py-2
          ma-0
          row
          :wrap="$vuetify.breakpoint.xsOnly"
          align-center
          justify-center
        >
          <v-flex shrink mr-auto mb-3>
            <v-toolbar-title v-show="!$vuetify.breakpoint.xsOnly">
              {{ $t('parents.tutors') }}
            </v-toolbar-title>
          </v-flex>

          <v-flex xs12 sm7 lg6 grow class="titleSearch">
            <v-text-field
              v-if="
                userPermissions[possibleUserModulePermissions.WATCH_PARENTS]
              "
              class="mx-3"
              flat
              :label="$t('parents.search')"
              :disabled="loading"
              prepend-inner-icon="search"
              @click:append-outer="filterSearch"
              @keyup.enter="filterSearch"
              @click:clear="clearSearch"
              v-model="filters.search"
              clearable
              solo-inverted
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm4 lg3 shrink>
            <clear-filters
              @click="removeFilters"
              v-if="filtersRemove"
            ></clear-filters>
            <div class="d-inline-block">
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn
                    v-on="on"
                    @click="deleteConfirm"
                    icon
                    v-if="
                      userPermissions[
                        possibleUserModulePermissions.DELETE_PARENTS
                      ]
                    "
                    :disabled="!(selected.length > 0)"
                  >
                    <v-icon color="primary">delete</v-icon>
                  </v-btn>
                </template>
                <span>{{ $t('parents.delete') }}</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn
                    v-on="on"
                    icon
                    @click="toast.edFlag = true"
                    v-if="
                      userPermissions[
                        possibleUserModulePermissions.SEND_PARENTS
                      ]
                    "
                    :disabled="selectedToSend.length < 1"
                  >
                    <v-icon color="primary" class="no-border">send</v-icon>
                  </v-btn>
                </template>
                <span>{{ $t('parents.send_code') }}</span>
              </v-tooltip>
            </div>
          </v-flex>
        </v-layout>
        <v-speed-dial
          v-if="userPermissions[possibleUserModulePermissions.WATCH_PARENTS]"
          key="1"
          absolute
          bottom
          left
          direction="bottom"
          open-on-hover
          transition="scale-transition"
          style="bottom: 0"
        >
          <template v-slot:activator>
            <v-tooltip
              right
              v-if="
                userPermissions[possibleUserModulePermissions.ADD_PARENTS] ||
                userPermissions[
                  possibleUserModulePermissions.DOWNLOAD_PARENTS
                ] ||
                userPermissions[
                  possibleUserModulePermissions.DOWNLOAD_STUDENTS_PARENTS
                ]
              "
            >
              <template v-slot:activator="{ on }">
                <v-btn
                  v-model="buttonFab.fab"
                  style="z-index: 99"
                  color="gradiente"
                  dark
                  fab
                  :small="$vuetify.breakpoint.xsOnly"
                  v-on="on"
                >
                  <v-icon>more_vert</v-icon>
                </v-btn>
              </template>
              <span>{{ $t('parents.options') }}</span>
            </v-tooltip>
          </template>
          <v-tooltip
            right
            v-if="userPermissions[possibleUserModulePermissions.ADD_PARENTS]"
          >
            <v-btn
              fab
              dark
              small
              color="gradiente"
              slot="activator"
              @click="addParent"
            >
              <v-icon>person_add</v-icon>
            </v-btn>
            <span>{{ $t('parents.create_tutor') }}</span>
          </v-tooltip>
          <v-tooltip
            right
            v-if="
              userPermissions[possibleUserModulePermissions.DOWNLOAD_PARENTS]
            "
          >
            <v-btn
              fab
              dark
              small
              color="gradiente"
              slot="activator"
              @click="downloadParents"
            >
              <v-icon>file_download</v-icon>
            </v-btn>
            <span>{{ $t('parents.download_tutors') }}</span>
          </v-tooltip>
          <v-tooltip
            right
            v-if="
              userPermissions[
                possibleUserModulePermissions.DOWNLOAD_STUDENTS_PARENTS
              ]
            "
          >
            <v-btn
              fab
              dark
              small
              color="gradiente"
              slot="activator"
              @click="downloadParentsStudents"
            >
              <v-icon>cloud_download</v-icon>
            </v-btn>
            <span>{{ $t('parents.download_tutors_and_students') }}</span>
          </v-tooltip>
          <v-tooltip right>
            <v-btn
              v-if="
                userPermissions[
                  possibleUserModulePermissions.DOWNLOAD_STUDENTS_PARENTS
                ] &&
                (totalItemsFromBackend > 0 || selected.length > 0)
              "
              fab
              dark
              small
              color="gradiente"
              slot="activator"
              @click="showQrSizeModalAll"
            >
              <v-icon>qr_code</v-icon>
            </v-btn>
            <span>Descargar masiva de Qrs</span>
          </v-tooltip>
        </v-speed-dial>
      </v-toolbar>
      <v-container fluid class="select-all-banner" v-if="selectAllBanner">
        <span v-if="allParentsSelected"
          >{{ totalItemsFromBackend }} tutores están seleccionados.
          &nbsp;&nbsp;&nbsp;&nbsp;<a @click.stop="toggleAll">Cancelar</a></span
        >
        <span v-else
          >Se han seleccionado {{ selected.length }} tutores.
          <a @click.stop="selectAll"
            >Seleccionar los {{ totalItemsFromBackend }} tutores</a
          >.&nbsp;&nbsp;&nbsp;&nbsp;<a @click.stop="closeSelectAllBanner"
            >X</a
          ></span
        >
      </v-container>
      <v-container fluid elevation-2 class="table-full">
        <v-layout row wrap>
          <v-flex xs12 class="test">
            <v-data-table
              v-model="selected"
              :headers="headers"
              :rows-per-page-items="[25, 50, 100]"
              :total-items="totalItemsFromBackend"
              :items="parents"
              :loading="loading"
              :expand="expand"
              :pagination.sync="pagination"
              ref="table"
              item-key="id"
              select-all
              :no-data-text="
                userPermissions[possibleUserModulePermissions.WATCH_PARENTS]
                  ? loading
                    ? 'Cargando'
                    : parents.length > 0
                    ? ''
                    : 'No hay tutores'
                  : 'No tienes permiso de ver tutores'
              "
            >
              <template v-slot:headers="props">
                <tr>
                  <th style="width: 78px; max-width: 78px; min-width: 78px">
                    <v-checkbox
                      :input-value="props.all"
                      :indeterminate="props.indeterminate"
                      primary
                      :disabled="loading"
                      color="primary"
                      hide-details
                      @click.stop="toggleAll"
                    ></v-checkbox>
                  </th>
                  <th style="width: 78px; max-width: 78px; min-width: 78px">
                    {{ $t('parents.photo') }}
                  </th>
                  <th
                    class="text-xs-left sortable_pick"
                    style="width: 215px; max-width: 215px; min-width: 215px"
                    @click="changeSort(props.headers[1].value)"
                  >
                    {{ $t('parents.first_name') }}
                    <SortTableArrow
                      :is-active="props.headers[1].value === pagination.sortBy"
                      :is-upward="pagination.descending"
                    />
                  </th>
                  <th
                    class="text-xs-left sortable_pick"
                    style="width: 222x; max-width: 222px; min-width: 222px"
                    @click="changeSort(props.headers[2].value)"
                  >
                    {{ $t('parents.last_name') }}
                    <SortTableArrow
                      :is-active="props.headers[2].value === pagination.sortBy"
                      :is-upward="pagination.descending"
                    />
                  </th>
                  <th
                    class="text-xs-left"
                    style="width: 280px; max-width: 280px; min-width: 280px"
                  >
                    {{ $t('parents.email') }}
                  </th>
                  <th
                    class="text-xs-left"
                    style="width: 100px; max-width: 100px; min-width: 100px"
                  >
                    {{ $t('parents.qr_code') }}
                  </th>
                  <th
                    class="text-xs-center"
                    style="
                      width: 185px;
                      max-width: 185px;
                      min-width: 185px;
                      text-align: center !important;
                    "
                    v-if="
                      userPermissions[
                        possibleUserModulePermissions.BLOCK_PARENTS_QR
                      ]
                    "
                  >
                    {{ $t('parents.qr_status') }}
                  </th>
                  <!-- <th
                    class="text-xs-left"
                    style="width: 178px; max-width: 178px; min-width: 178px"
                  >
                    Tutorados
                  </th> -->
                  <th
                    class="text-xs-left"
                    style="width: 178px; max-width: 178px; min-width: 178px"
                  >
                    <v-select
                      multiple
                      :items="
                        userPermissions[
                          possibleUserModulePermissions.WATCH_STUDENTS
                        ]
                          ? props.headers[4].filterItems
                          : []
                      "
                      outline
                      height="50"
                      :disabled="loading"
                      @change="filterNumStds"
                      :dense="$vuetify.breakpoint.xsOnly"
                      v-model="filters.studentCounts"
                      full-width
                    >
                      <template v-slot:label>
                        <span class="grey--text">{{
                          props.headers[4].text
                        }}</span>
                      </template>
                      <template v-slot:selection="{ item, index }">
                        <span
                          v-if="
                            filters.studentCounts &&
                            index === filters.studentCounts.length - 1
                          "
                          class="grey--text caption"
                          >(
                          {{
                            '+' +
                            filters.studentCounts.length +
                            ' filtro' +
                            (filters.studentCounts.length > 1 ? 's' : '')
                          }}
                          )</span
                        >
                      </template>
                    </v-select>
                  </th>
                  <th style="width: 120px; max-width: 120px; min-width: 120px">
                    {{ $t('parents.automobiles') }}
                  </th>
                  <th style="width: 120px; max-width: 120px; min-width: 120px">
                    {{ $t('parents.drivers') }}
                  </th>
                  <th
                    class="text-xs-left"
                    style="width: 150px; max-width: 150px; min-width: 150px"
                  >
                    <v-select
                      multiple
                      :items="
                        userPermissions[
                          possibleUserModulePermissions.WATCH_STUDENTS
                        ]
                          ? props.headers[7].filterItems
                          : []
                      "
                      item-text="label"
                      item-value="value"
                      outline
                      height="50"
                      :disabled="loading"
                      @change="filterRegistry"
                      :dense="$vuetify.breakpoint.xsOnly"
                      v-model="filters.registry"
                      full-width
                    >
                      <template v-slot:label>
                        <span class="grey--text">{{
                          props.headers[7].text
                        }}</span>
                      </template>
                      <template v-slot:selection="{ item, index }">
                        <span
                          v-if="
                            filters.registry &&
                            index === filters.registry.length - 1
                          "
                          class="grey--text caption"
                          >(
                          {{
                            '+' +
                            filters.registry.length +
                            ' filtro' +
                            (filters.registry.length > 1 ? 's' : '')
                          }}
                          )</span
                        >
                      </template>
                    </v-select>
                  </th>
                  <th
                    class="text-center"
                    style="width: 230px; max-width: 230px; min-width: 230px"
                  >
                    {{ $t('parents.last_login') }}
                  </th>
                  <th
                    style="width: 160px; max-width: 160px; min-width: 160px"
                  ></th>
                </tr>
              </template>
              <template v-slot:items="props">
                <td
                  style="width: 78px; max-width: 78px; min-width: 78px"
                  v-if="
                    userPermissions[
                      possibleUserModulePermissions.DELETE_PARENTS
                    ] ||
                    userPermissions[
                      possibleUserModulePermissions.UPDATE_PARENTS
                    ]
                  "
                  :class="props.item.id == colapSel ? 'little-green' : ''"
                >
                  <v-checkbox
                    color="primary"
                    v-model="props.selected"
                    primary
                    hide-details
                    @change="toggleSingle"
                  >
                  </v-checkbox>
                </td>
                <td
                  class="text-xs-left"
                  style="width: 78px; max-width: 78px; min-width: 78px"
                  :class="props.item.id == colapSel ? 'little-green' : ''"
                >
                  <v-avatar
                    :tile="tile"
                    :size="avatarSize"
                    color="grey lighten-4"
                    v-if="
                      props.item.imageStorage &&
                      props.item.imageStorage.miniObjUrl
                    "
                  >
                    <img
                      :key="ck"
                      :src="props.item.imageStorage.miniObjUrl"
                      alt="avatar"
                    />
                  </v-avatar>
                  <v-icon v-else>account_circle</v-icon>
                </td>
                <td
                  class="text-xs-left"
                  style="width: 215px; max-width: 215px; min-width: 215px"
                  :class="
                    props.item.id == colapSel
                      ? 'little-green'
                      : '' + ' widthFirstName'
                  "
                >
                  {{ props.item.firstName }}
                </td>
                <td
                  class="text-xs-left"
                  style="width: 222px; max-width: 222px; min-width: 222px"
                  :class="
                    props.item.id == colapSel
                      ? 'little-green'
                      : '' + ' widthLastName'
                  "
                >
                  {{ props.item.lastName }}
                </td>
                <td
                  class="text-xs-left"
                  style="width: 280px; max-width: 280px; min-width: 280px"
                  :class="
                    props.item.id == colapSel
                      ? 'little-green'
                      : '' + ' widthMail'
                  "
                >
                  {{ props.item.mail }}
                </td>
                <td
                  class="text-xs-left"
                  style="width: 100px; max-width: 100px; min-width: 100px"
                  :class="props.item.id == colapSel ? 'little-green' : ''"
                >
                  <v-btn
                    icon
                    v-if="props.item.qr"
                    @click="showQrSizeModal(props.item)"
                  >
                    <v-avatar
                      :tile="tile"
                      :size="avatarSize"
                      color="grey lighten-4"
                    >
                      <img
                        :key="ck"
                        :src="'data:image/jpg;base64, ' + props.item.qr"
                        alt="avatar"
                      />
                    </v-avatar>
                  </v-btn>
                  <v-icon v-else>no_sim</v-icon>
                </td>
                <td
                  class="text-xs-left"
                  style="
                    width: 185px;
                    max-width: 185px;
                    min-width: 185px;
                    color: green;
                    font-weight: bold;
                    text-align-last: left;
                  "
                  v-if="
                    userPermissions[
                      possibleUserModulePermissions.BLOCK_PARENTS_QR
                    ] && props.item.qrEnabled == true
                  "
                  :class="props.item.id == colapSel ? 'little-green' : ''"
                >
                  <v-tooltip left>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        v-bind="attrs"
                        v-on="on"
                        @click="bloqQR(props.item)"
                        icon
                      >
                        <v-icon>lock_open</v-icon>
                      </v-btn>
                    </template>
                    <span>{{ $t('parents.suspend_qr') }}</span>
                  </v-tooltip>
                  Activo
                </td>

                <td
                  class="text-xs-left"
                  style="
                    width: 185px;
                    max-width: 185px;
                    min-width: 185px;
                    color: red;
                    font-weight: bold;
                    text-align-last: left;
                  "
                  v-if="
                    userPermissions[
                      possibleUserModulePermissions.BLOCK_PARENTS_QR
                    ] && props.item.qrEnabled == false
                  "
                  :class="props.item.id == colapSel ? 'little-green' : ''"
                >
                  <v-tooltip left>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        v-bind="attrs"
                        v-on="on"
                        @click="desbloqQR(props.item)"
                        icon
                      >
                        <v-icon>lock</v-icon>
                      </v-btn>
                    </template>
                    <span>Activar QR</span>
                  </v-tooltip>

                  <v-tooltip right max-width="250px">
                    <template v-slot:activator="{ on, attrs }">
                      <span v-bind="attrs" v-on="on">Suspendido</span>
                    </template>
                    <span>{{ props.item.qrDisabledReason }}</span>
                  </v-tooltip>
                </td>
                <td
                  style="width: 178px; max-width: 178px; min-width: 178px"
                  v-if="
                    userPermissions[
                      possibleUserModulePermissions.WATCH_STUDENTS
                    ]
                  "
                  @click="expandStudents(props)"
                  :class="props.item.id == colapSel ? 'little-green' : ''"
                >
                  <v-btn icon>
                    <v-badge
                      :color="props.item.studentList.length ? 'green' : 'red'"
                    >
                      <template v-slot:badge>
                        <span>{{ props.item.studentList.length }}</span>
                      </template>
                      <v-icon class="no-border">
                        {{
                          !props.item.studentList.length
                            ? 'person_outline'
                            : props.item.studentList.length == 1
                            ? 'person'
                            : 'group'
                        }}
                      </v-icon>
                    </v-badge>
                  </v-btn>
                </td>
                <td
                  class="text-xs-left"
                  style="width: 178px; max-width: 178px; min-width: 178px"
                  v-else
                  :class="props.item.id == colapSel ? 'little-green' : ''"
                >
                  No autorizado
                </td>

                <td
                  style="width: 120px; max-width: 120px; min-width: 120px"
                  v-if="
                    userPermissions[possibleUserModulePermissions.WATCH_CARS]
                  "
                  @click="expandCars(props)"
                  :class="props.item.id == colapSel ? 'little-green' : ''"
                >
                  <v-btn icon>
                    <v-badge :color="props.item.carCount ? 'green' : 'red'">
                      <template v-slot:badge>
                        <span>{{ props.item.carCount }}</span>
                      </template>
                      <v-icon>directions_car</v-icon>
                    </v-badge>
                  </v-btn>
                </td>
                <td
                  class="text-xs-left"
                  style="width: 120px; max-width: 120px; min-width: 120px"
                  v-else
                  :class="props.item.id == colapSel ? 'little-green' : ''"
                >
                  No autorizado
                </td>

                <td
                  style="width: 120px; max-width: 120px; min-width: 120px"
                  @click="expandChofers(props)"
                  :class="props.item.id == colapSel ? 'little-green' : ''"
                >
                  <v-btn icon>
                    <v-badge :color="props.item.driverCount ? 'green' : 'red'">
                      <template v-slot:badge>
                        <span>{{ props.item.driverCount }}</span>
                      </template>
                      <v-icon>airline_seat_recline_normal</v-icon>
                    </v-badge>
                  </v-btn>
                </td>

                <td
                  class="text-xs-left widthCode"
                  style="width: 150px; max-width: 150px; min-width: 150px"
                  :class="props.item.id == colapSel ? 'little-green' : ''"
                >
                  <span
                    v-if="
                      userPermissions[
                        possibleUserModulePermissions.WATCH_PARENTS_CODE
                      ]
                    "
                  >
                    <v-layout v-if="props.item.code" row wrap>
                      <HideCode :text="props.item.code"></HideCode>
                    </v-layout>
                    <div
                      v-else
                      :class="props.item.id == colapSel ? 'little-green' : ''"
                    >
                      {{ $t('parents.registered') }}
                    </div>
                  </span>
                  <span
                    class="text-xs-left"
                    v-else
                    :class="props.item.id == colapSel ? 'little-green' : ''"
                    >No autorizado</span
                  >
                </td>
                <td
                  style="width: 230px; max-width: 230px; min-width: 230px"
                  :class="props.item.id == colapSel ? 'little-green' : ''"
                >
                  {{ props.item.lastLoggedInString }}
                </td>
                <td
                  class="text-xs-left"
                  style="width: 160px; max-width: 160px; min-width: 160px"
                  v-if="
                    userPermissions[
                      possibleUserModulePermissions.UPDATE_PARENTS
                    ]
                  "
                  :class="props.item.id == colapSel ? 'little-green' : ''"
                >
                  <v-tooltip left>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        v-bind="attrs"
                        v-on="on"
                        icon
                        @click="editParent(props.item)"
                      >
                        <v-icon>edit</v-icon>
                      </v-btn>
                    </template>
                    <span>{{ $t('parents.edit_tutor') }}</span>
                  </v-tooltip>
                </td>
              </template>
              <template v-slot:expand="props">
                <TutorStudents
                  v-if="expandables.students"
                  :students="props.item.studentList"
                  :parent-name="props.item.firstName"
                  :permits="userPermissions"
                  :parent-id="props.item.id"
                ></TutorStudents>

                <Cars
                  :parent-id="props.item.id"
                  v-else-if="expandables.cars"
                ></Cars>

                <Familiars
                  :parent-id="props.item.id"
                  :permits="userPermissions"
                  v-else-if="expandables.familiars"
                ></Familiars>

                <Chofers
                  @driverCreated="onDriverCreated"
                  @qtyDriversRemoved="onQtyDriversRemoved"
                  :parent-id="props.item.id"
                  v-else-if="expandables.chofers"
                ></Chofers>
              </template>
            </v-data-table>
          </v-flex>
        </v-layout>
      </v-container>
    </v-layout>
    <TutorModal
      :class="!modals.parent ? 'position-no' : ''"
      :title="modals.title"
      v-model="modals.parent"
      :parent="select.parent"
      v-on:created="createParent"
      v-on:updated="updateParent"
      :permits="userPermissions"
      @deletePhoto="deletePhoto"
    ></TutorModal>

    <desition
      :class="!confirm.value ? 'position-no' : ''"
      :value="confirm.value"
      :title="confirm.title"
      :description="confirm.description"
      v-on:desition="desitionDelete"
    ></desition>

    <QRSizeModal
      :class="!QRSizeModal.value ? 'position-no' : ''"
      v-model="QRSizeModal.value"
      :value="QRSizeModal.value"
      :title="QRSizeModal.title"
      v-on:desition="desitionSize"
    ></QRSizeModal>

    <loading v-model="working.wLoading" text="Trabajando"></loading>
    <success v-model="toast.success" text="Operación Exitosa"></success>
    <success v-model="toast.sent" :text="sendResult"></success>
    <error v-model="toast.failed" text="Ups ocurrió un error"></error>
    <desition
      @desition="$event ? resendEmail() : ''"
      v-model="toast.edFlag"
      title="Envío de correo"
      description="Se enviará el correo con el código de registro solo a los usuarios pendientes de registrar.<br/><br/> ¿Deseas continuar con la operación?"
    ></desition>
    <QRBlock
      v-model="blockQR"
      :student="select.parent"
      @updated="updateParent"
      :par="true"
    ></QRBlock>
    <QRDesblock
      v-model="desblockQR"
      :student="select.parent"
      @updated="updateParent"
      :par="true"
    ></QRDesblock>
  </v-container>
</template>
<script>
import { mapGetters } from 'vuex'
import { funciones } from '../../../Mixins/Funciones'
import { pdfMixin } from '../../../Mixins/PdfMixin'
import { _getUserPermissions } from '../../../utils/genericUtils.js'
import desition from '../../Dialogs/Confirm'
import error from '../../Dialogs/Error'
import FilterRemove from '../../Dialogs/FilterSelectRemoving'
import loading from '../../Dialogs/Loading'
import success from '../../Dialogs/Success'
import QRBlock from '../../Modals/BloqQR'
import QRDesblock from '../../Modals/DesbloqQR'
import QRSizeModal from '../../Modals/QRSizeModal.vue'
import TutorModal from '../../Modals/TutorModal.vue'
import Cars from '../../Sections/Tutor/Cars.vue'
import Chofers from '../../Sections/Tutor/Chofers.vue'
import Familiars from '../../Sections/Tutor/Familiars.vue'
import TutorStudents from '../../Sections/Tutor/Tutor-Students.vue'
import ClearFilters from '../../Tools/ClearFilters.vue'
import HideCode from '../../Tools/HideCode'
import SortTableArrow from '../../Tools/SortTableArrow.vue'

export default {
  components: {
    TutorModal,
    confirm,
    TutorStudents,
    Chofers,
    HideCode,
    loading,
    success,
    error,
    QRSizeModal,
    Cars,
    Familiars,
    FilterRemove,
    desition,
    ClearFilters,
    QRBlock,
    QRDesblock,
    SortTableArrow,
  },
  mixins: [funciones, pdfMixin],
  props: {},
  data: () => {
    return {
      counterChofers: [],
      parents: [],
      avatarSize: '30px',
      gotImages: 0,
      ck: 0,
      loading: true,
      expand: false,
      selectAllBanner: false,
      allParentsSelected: false,
      working: {
        wParent: false,
        wLoading: false,
      },
      expandables: {
        students: false,
        cars: false,
        familiars: false,
        chofers: false,
      },
      totalItemsFromBackend: 0,
      user: {},
      tile: false,
      sendResult: '',
      headers: [
        {
          text: 'Foto',
          align: 'center',
          value: 'photo',
          sortable: false,
          langKey: 'parents.photo',
        },
        {
          text: 'Nombre',
          value: 'NAME',
          align: 'center',
          sortable: true,
          langKey: 'parents.first_name',
        },
        {
          text: 'Apellidos',
          value: 'LAST_NAME',
          sortable: true,
          langKey: 'parents.last_name',
        },
        {
          text: 'Correo',
          value: 'mail',
          sortable: true,
          langKey: 'parents.email',
        },
        {
          text: 'Tutorados',
          value: 'students',
          // filterItems: [],
          sortable: false,
          langKey: 'parents.tutored',
        },
        {
          text: 'Automóviles',
          value: 'automoviles',
          sortable: false,
          langKey: 'parents.automobiles',
        },
        {
          text: 'Choferes',
          value: 'owner',
          sortable: false,
          langKey: 'parents.drivers',
        },
        {
          text: 'Estatus',
          value: 'status',
          filterItems: [
            {
              value: 'YES',
              label: 'No registrado',
              langKey: 'parents.not_registered',
            },
            {
              value: 'NO',
              label: 'Registrados',
              langKey: 'parents.registered',
            },
          ],
          sortable: false,
          langKey: 'parents.status',
        },
        {
          text: 'Último inicio de sesión',
          value: 'lastLoggedIn',
          align: 'center',
          sortable: true,
          langKey: 'parents.last_login',
        },
        {
          text: '',
          value: 'actions',
          sortable: true,
          langKey: '',
        },
      ],
      pagination: {
        sortBy: 'NAME',
        rowsPerPage: 25,
        descending: false,
        total: 0,
      },
      buttonFab: {
        fab: false,
        hidden: false,
      },
      selected: [],

      modals: {
        title: '',
        parent: false,
        import: false,
      },
      select: {
        parent: null,
      },
      toast: {
        success: false,
        failed: false,
        remove: false,
        edFlag: false,
        sent: false,
      },
      confirm: {
        value: false,
        title: '',
        description: '',
        show: false,
      },
      parentSendEmail: {},
      QRSizeModal: {
        title: '',
        value: '',
        parent: null,
      },
      userPermissions: {},
      possibleUserModulePermissions: {
        // STUDENTS / PARENTS
        DOWNLOAD_STUDENTS_PARENTS: 'DOWNLOAD_STUDENTS_PARENTS',
        IMPORT_STUDENTS_PARENTS: 'IMPORT_STUDENTS_PARENTS',
        // TUTORS / PARENTS
        WATCH_PARENTS: 'WATCH_PARENTS',
        ADD_PARENTS: 'ADD_PARENTS',
        UPDATE_PARENTS: 'UPDATE_PARENTS',
        DELETE_PARENTS: 'DELETE_PARENTS',
        SEND_PARENTS: 'SEND_PARENTS',
        LINK_STUDENTS_PARENTS: 'LINK_STUDENTS_PARENTS',
        DOWNLOAD_PARENTS: 'DOWNLOAD_PARENTS',
        WATCH_PARENTS_CODE: 'WATCH_PARENTS_CODE',
        BLOCK_PARENTS_QR: 'BLOCK_PARENTS_QR',
        // STUDENTS
        WATCH_STUDENTS: 'WATCH_STUDENTS',
        ADD_STUDENTS: 'ADD_STUDENTS',
        DELETE_STUDENTS: 'DELETE_STUDENTS',
        UPDATE_STUDENTS: 'UPDATE_STUDENTS',
        DOWNLOAD_STUDENTS: 'DOWNLOAD_STUDENTS',
        DOWNLOAD_STUDENTS_PARENTS: 'DOWNLOAD_STUDENTS_PARENTS',
        IMPORT_STUDENTS: 'IMPORT_STUDENTS',
        IMPORT_STUDENTS_PARENTS: 'IMPORT_STUDENTS_PARENTS',
        LINK_STUDENTS_PARENTS: 'LINK_STUDENTS_PARENTS',
        BLOCK_STUDENTS_QR: 'BLOCK_STUDENTS_QR',
        // CARS
        WATCH_CARS: 'WATCH_CARS',
        // QR
        WATCH_QR: 'WATCH_QR',
        ADD_QR: 'ADD_QR',
        DOWNLOAD_QR: 'DOWNLOAD_QR',
        BLOCK_STUDENTS_QR: 'BLOCK_STUDENTS_QR',
        BLOCK_PARENTS_QR: 'BLOCK_PARENTS_QR',
        BLOCK_COLAB_QR: 'BLOCK_COLAB_QR',
      },
      colapSel: null,
      filters: {
        studentCounts: [],
        size: 25,
        offset: 0,
        orderBy: 'NAME',
        orderType: 'asc',
        // students: [],
        search: '',
        numStd: [],
        registry: [],
      },
      firstCharge: false,
      blockQR: false,
      desblockQR: false,
    }
  },
  watch: {
    getLang() {
      this.setLang()
    },
    getBranch() {
      if (
        this.userPermissions[
          this.possibleUserModulePermissions.WATCH_PARENTS
        ] &&
        this.parents.length == 0
      ) {
        this.filters.size = 25
        this.filters.offset = 0
        this.filters.orderBy = 'NAME'
        this.filters.orderType = 'ASC'
        this.getParentsOfBranch()
      }
    },
    getUser() {
      this.mapPermits()
      if (
        this.userPermissions[
          this.possibleUserModulePermissions.WATCH_PARENTS
        ] &&
        !this.parents &&
        this.getBranch.id
      ) {
        this.filters.size = 25
        this.filters.offset = 0
        this.filters.orderBy = 'NAME'
        this.filters.orderType = 'ASC'
        // nota: se evita doble llamada "onreload"
        // this.getParentsOfBranch();
      }
    },
    pagination: {
      handler() {
        if (
          this.userPermissions[
            this.possibleUserModulePermissions.WATCH_PARENTS
          ] &&
          this.parents &&
          this.getBranch.id &&
          this.pagination.rowsPerPage &&
          this.pagination.page &&
          this.pagination.sortBy
        ) {
          this.filters.size = this.pagination.rowsPerPage
          this.filters.offset =
            (this.pagination.page - 1) * this.pagination.rowsPerPage
          this.filters.orderBy = this.pagination.sortBy
          this.filters.orderType = this.pagination.descending ? 'DESC' : 'ASC'
          this.getParentsOfBranch()
        }
      },
      deep: true,
    },
  },

  mounted() {
    if (this.getUser.id) {
      this.mapPermits()
    }
    this._setFilters()
    this.setLang()
  },
  methods: {
    setLang() {
      for (let i = 0; i < this.headers.length; i++) {
        const el = this.headers[i]
        el.text = this.$t(el.langKey)
      }

      const statusHeaderIndex = this.headers.findIndex(
        (e) => e.value === 'status'
      )
      for (
        let i = 0;
        i < this.headers[statusHeaderIndex].filterItems.length;
        i++
      ) {
        const el = this.headers[statusHeaderIndex].filterItems[i]
        el.label = this.$t(el.langKey)
      }
    },
    onDriverCreated(parentId) {
      const parentIdIndex = this.parents.findIndex((e) => e.id === parentId)
      this.parents[parentIdIndex].driverCount = ++this.parents[parentIdIndex]
        .driverCount
    },
    onQtyDriversRemoved(parentId) {
      const parentIdIndex = this.parents.findIndex((e) => e.id === parentId)
      this.parents[parentIdIndex].driverCount = --this.parents[parentIdIndex]
        .driverCount
    },
    async _setFilters() {
      const response = await this.$store.dispatch('tutor/getTutorsFilters')
      this.headers[4].filterItems = response.data
    },
    deletePhoto(id) {
      this.working.wLoading = true
      this.$store
        .dispatch('tutor/deleteImage', id)
        .then(() => {
          this.working.wLoading = false
          this.toast.success = true
          this.modals.parent = false
          this.getParentsOfBranch()
        })
        .catch((error) => {
          console.log(error)
          this.working.wLoading = false
          this.toast.failed = true
        })
    },
    bloqQR(parent) {
      this.select.parent = parent
      this.blockQR = true
    },
    desbloqQR(parent) {
      this.select.parent = parent
      this.desblockQR = true
    },
    mapPermits() {
      this.userPermissions = _getUserPermissions({
        getUser: this.getUser,
        possibleUserModulePermissions: this.possibleUserModulePermissions,
      })
    },
    changeSort(column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending
      } else {
        this.pagination.sortBy = column
        this.pagination.descending = false
      }
    },
    expandStudents(props) {
      if (this.colapSel != props.item.id) {
        props.expanded = !props.expanded
        this.expandables = {
          students: false,
          cars: false,
          familiars: false,
          chofers: false,
        }
      }
      this.colapSel = props.item.id
      if (props.expanded && this.expandables.students) {
        props.expanded = !props.expanded
        this.expandables = {
          students: false,
          cars: false,
          familiars: false,
          chofers: false,
        }
        this.colapSel = null
      } else if (!props.expanded && !this.expandables.students) {
        props.expanded = !props.expanded

        this.expandables = {
          students: true,
          cars: false,
          familiars: false,
          chofers: false,
        }
      } else if (props.expanded && !this.expandables.students) {
        this.expandables = {
          students: true,
          cars: false,
          familiars: false,
          chofers: false,
        }
      }
    },
    expandCars(props) {
      if (this.colapSel != props.item.id) {
        props.expanded = !props.expanded
        this.expandables = {
          students: false,
          cars: false,
          familiars: false,
          chofers: false,
        }
      }
      this.colapSel = props.item.id
      if (props.expanded && this.expandables.cars) {
        props.expanded = !props.expanded
        this.expandables = {
          cars: false,
          students: false,
          familiars: false,
          chofers: false,
        }

        this.colapSel = null
      } else if (!props.expanded && !this.expandables.cars) {
        props.expanded = !props.expanded

        this.expandables = {
          cars: true,
          students: false,
          familiars: false,
          chofers: false,
        }
      } else if (props.expanded && !this.expandables.cars) {
        this.expandables = {
          cars: true,
          students: false,
          familiars: false,
          chofers: false,
        }
      }
    },
    expandFamiliars(props) {
      if (this.colapSel != props.item.id) {
        props.expanded = !props.expanded
        this.expandables = {
          students: false,
          cars: false,
          familiars: false,
          chofers: false,
        }
      }
      this.colapSel = props.item.id
      if (props.expanded && this.expandables.familiars) {
        props.expanded = !props.expanded
        this.expandables = {
          cars: false,
          students: false,
          familiars: false,
          chofers: false,
        }

        this.colapSel = null
      } else if (!props.expanded && !this.expandables.familiars) {
        props.expanded = !props.expanded

        this.expandables = {
          cars: false,
          students: false,
          familiars: true,
          chofers: false,
        }
      } else if (props.expanded && !this.expandables.familiars) {
        this.expandables = {
          cars: false,
          students: false,
          familiars: true,
          chofers: false,
        }
      }
    },
    expandChofers(props) {
      if (this.colapSel != props.item.id) {
        props.expanded = !props.expanded
        this.expandables = {
          students: false,
          cars: false,
          familiars: false,
          chofers: false,
        }
      }
      this.colapSel = props.item.id
      if (props.expanded && this.expandables.chofers) {
        props.expanded = !props.expanded
        this.expandables = {
          cars: false,
          students: false,
          familiars: false,
          chofers: false,
        }

        this.colapSel = null
      } else if (!props.expanded && !this.expandables.chofers) {
        props.expanded = !props.expanded

        this.expandables = {
          cars: false,
          students: false,
          familiars: false,
          chofers: true,
        }
      } else if (props.expanded && !this.expandables.chofers) {
        this.expandables = {
          cars: false,
          students: false,
          familiars: false,
          chofers: true,
        }
      }
    },
    getParentsOfBranch() {
      this.loading = true
      this.$store
        .dispatch('tutor/getTutors', this.filters)
        .then((response) => {
          this.parents = response.data.data
          this.totalItemsFromBackend = response.data.total
          this.firstCharge = true
          this.loading = false
          this.selectAllBanner = false
          this.allParentsSelected = false
          // response.data.filters.students.unshift(0)

          // this.applyFilters(response.data.filters)
          // this.$forceUpdate()
        })
        .catch((error) => {
          this.loading = false
          this.selected = []
          this.toast.failed = true
        })
    },
    // filterNumOfStudents() {
    //   var listChilds = []
    //   var count = 0
    //   for (parent in this.parents) {
    //     listChilds[this.parents[parent].students.length] = 1
    //   }
    //   for (var num in listChilds) {
    //     if (listChilds[num]) {
    //       this.headers[4].filterItems.push(num)
    //     }
    //   }
    // },
    // applyFilters(newFilters) {
    //   if (this.filters.students.length == 0) {
    //     this.headers[4].filterItems = []
    //     for (const [index, item] of newFilters.students.entries()) {
    //       this.headers[4].filterItems.push(item)
    //     }
    //     this.$forceUpdate()
    //   }
    // },
    toggleSingle(value) {
      if (this.selected.length !== this.parents.length) {
        this.selectAllBanner = false
        this.allParentsSelected = false
      } else if (this.selected.length !== this.totalItemsFromBackend) {
        this.selectAllBanner = true
        this.allParentsSelected = false
      }
    },
    toggleAll() {
      this.allParentsSelected = false
      if (this.selected.length) {
        this.selected = []
        this.selectAllBanner = false
      } else {
        this.selected = this.$refs.table.filteredItems.slice()
        this.selectAllBanner =
          this.selected.length !== this.totalItemsFromBackend
      }
    },
    selectAll(event) {
      event.preventDefault()
      this.allParentsSelected = true
    },
    closeSelectAllBanner(event) {
      event.preventDefault()
      this.selectAllBanner = false
      this.allParentsSelected = false
    },
    // filterStudents(val) {
    //   this.filters = this.$MultiFilters.updateFilters(this.filters.numStd, {
    //     numStd: val,
    //   })
    // },
    customFilter(items, filters, filter, headers) {
      const cf = new this.$MultiFilters(items, filters, filter, headers)

      cf.registerFilter('search', function (searchWord, items) {
        if (searchWord == null || searchWord.trim() === '') return items
        var transformMap = {
          a: '[aá]',
          e: '[eé]',
          i: '[ií]',
          o: '[oó]',
          u: '[uí]',
          A: '[AÁ]',
          E: '[EÉ]',
          I: '[IÍ]',
          O: '[OÓ]',
          U: '[UÚ]',
        }
        var search = searchWord ? searchWord : ''
        search = search.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
        for (var key in transformMap) {
          search = search.replace(key, transformMap[key])
        }
        var matcher = new RegExp(search, 'i')
        return items.filter((item) => {
          return matcher.test(
            [
              item.firstName,
              item.lastName,
              item.firstName + ' ' + item.lastName,
              item.mail,
            ].join()
          )
        }, searchWord)
      })

      cf.registerFilter('numStd', function (numStd, items) {
        if (numStd.length == 0) return items

        return items.filter((item) => {
          for (var n in numStd) {
            if (item.students.length == numStd[n]) {
              return true
            }
          }
          return false
        }, numStd)
      })
      return cf.runFilters()
    },
    filterSearch(val) {
      this.getParentsOfBranch()
    },
    filterRegistry(val) {
      if (!this.loading) {
        this.filters.registry = val
        this.getParentsOfBranch()
      }
    },
    filterNumStds(val) {
      if (!this.loading) {
        // this.filters.students = val
        this.getParentsOfBranch()
      }
    },
    addParent(event = null) {
      this.select.parent = null
      this.modals.title = this.$t('parents.create_tutor')
      this.modals.parent = true
    },
    editParent(parent) {
      this.select.parent = parent
      this.modals.parent = true
      this.modals.title = this.$t('parents.edit_tutor')
    },
    createParent(event) {
      event.image = 'data:image/jpeg;base64,' + event.image
      this.parents.unshift(event)
      this.getParentsOfBranch()
      this.$forceUpdate()
    },
    updateParent(event) {
      var i = this.parents.indexOf(this.select.parent)
      this.parents[i].id = event.id
      this.parents[i].firstName = event.firstName
      this.parents[i].lastName = event.lastName
      this.parents[i].mail = event.mail

      this.select.parent = null
      this.selected = []
      this.ck += 1
      this.getParentsOfBranch()
      this.$forceUpdate()
    },
    deleteConfirm() {
      this.confirm.description =
        'Esta a punto de eliminar ' +
        (this.selected.length == 1
          ? 'a ' + this.selected[0].firstName + ' ' + this.selected[0].lastName
          : this.selected.length + ' tutores.\n') +
        ' ¿Está seguro que desea realizar dicha acción?'
      this.confirm.value = true
      this.confirm.title = 'Confirmación'
      this.confirm.show = true
    },
    desitionDelete(e) {
      if (e) {
        this.deleteParents()
      } else {
        this.confirm.value = false
      }
    },
    deleteParents() {
      this.working.wLoading = true
      this.$store
        .dispatch('tutor/deleteTutors', this.selected)
        .then((response) => {
          for (var e in this.selected) {
            this.parents.splice(this.parents.indexOf(this.selected[e]), 1)
          }
          this.selected = []
          this.working.wLoading = false
          this.toast.success = true
          this.confirm.value = false
          this.getParentsOfBranch()
          this.$forceUpdate()
        })
        .catch((error) => {
          this.toast.failed = true
          this.working.wLoading = false
          this.confirm.value = false
        })
    },
    downloadParents() {
      const filtros = {
        studentCounts: this.filters.studentCounts,
        search: this.filters.search,
        registry: this.filters.registry,
        orderBy: this.filters.orderBy,
        orderType: this.filters.orderType,
        numStd: this.filters.numStd,
        parents:
          this.selected.length === 0
            ? undefined
            : this.selected.map((e) => e.id),
        size: this.selected.length === 0 ? 0 : undefined,
      }

      this.working.wLoading = true
      this.$store
        .dispatch('tutor/getParentsByBranchToCsv', filtros)
        .then((response) => {
          var url = window.URL.createObjectURL(response.data)
          var a = document.createElement('a')
          a.href = url
          a.download = 'tutores.xlsx'
          a.click()
          a.remove()
          setTimeout(() => window.URL.revokeObjectURL(url), 100)
          this.working.wLoading = false
          this.toast.success = true
        })
        .catch((error) => {
          this.working.wLoading = false
          this.toast.failed = true
          console.log(error)
        })
    },
    downloadParentsStudents() {
      const filtros = {
        studentCounts: this.filters.studentCounts,
        search: this.filters.search,
        registry: this.filters.registry,
        orderBy: this.filters.orderBy,
        orderType: this.filters.orderType,
        numStd: this.filters.numStd,
        parents:
          this.selected.length === 0
            ? undefined
            : this.selected.map((e) => e.id),
        size: this.selected.length === 0 ? 0 : undefined,
      }

      this.working.wLoading = true
      this.$store
        .dispatch('tutor/getParentsStudentsByBranchToCsv', filtros)
        .then((response) => {
          var url = window.URL.createObjectURL(response.data)
          var a = document.createElement('a')
          a.href = url
          a.download = 'tutores-alumnos.xlsx'
          a.click()
          a.remove()
          setTimeout(() => window.URL.revokeObjectURL(url), 100)
          this.working.wLoading = false
          this.toast.success = true
        })
        .catch((error) => {
          this.working.wLoading = false
          this.toast.failed = true
          console.log(error)
        })
    },
    resendEmail() {
      this.working.wLoading = true
      var allFilter = JSON.parse(JSON.stringify(this.filters))
      allFilter.size = -1
      allFilter.offset = -1

      var request = this.allParentsSelected
        ? { filter: allFilter }
        : { ids: this.selectedToSend.map((el) => el.id) }
      this.$store
        .dispatch('tutor/resendEmailV2', request)
        .then((response) => {
          this.working.wLoading = false
          this.sendResult =
            'El correo se envió a ' +
            response.data.entity.success +
            ' de ' +
            response.data.entity.found +
            ' tutores.'
          this.toast.sent = true
          this.$forceUpdate()
        })
        .catch((error) => {
          console.log(error)
          this.working.wLoading = false
          this.toast.failed = true
        })
    },

    desitionSize(e) {
      this.QRSizeModal.value = false
      if (!e.value) {
        this.allQrs = false
        return
      }
      if (this.QRSizeModal.parent != null) {
        if (this.selected.find((a) => a.id === this.QRSizeModal.parent.id)) {
        } else {
          this.selected.push(this.QRSizeModal.parent)
        }
      }

      if (true) {
        if (this.selected.length > 0) {
          this.downloadParentMasiveQR(this.selected, e.size, this.getBranch)
        } else {
          this.downloadParentAllQR(e.size)
        }
      }
      if (this.QRSizeModal.parent != null) {
        var a = this.selected.indexOf(this.QRSizeModal.parent)
        this.selected.splice(a, 1)
      }

      this.QRSizeModal.parent = null
    },
    // _genericDownloadFile({
    //   documentName = 'document',
    //   extension = 'pdf',
    //   blob = new Blob(),
    // }) {
    //   const url = window.URL.createObjectURL(blob)
    //   const a = document.createElement('a')
    //   a.href = url
    //   a.download = `${documentName}.${extension}`
    //   a.click()
    //   a.remove()
    //   setTimeout(() => window.URL.revokeObjectURL(url), 100)
    // },
    downloadParentAllQR(size) {
      this.working.wLoading = true
      this.allQrs = false

      const temp = structuredClone(this.filters)
      delete temp.size
      delete temp.offset

      this.$store
        .dispatch('tutor/getTutors', temp)
        // .dispatch('tutor/getMasiveQrDownloadPdf', temp)
        .then((response) => {
          // this._genericDownloadFile({
          //   documentName: 'tutores.pdf',
          //   blob: response.data,
          //   extension: 'pdf',
          // })
          this.downloadParentMasiveQR(response.data.data, size, this.getBranch)
          this.working.wLoading = false
          this.toast.success = true
        })
        .catch((error) => {
          this.toast.failed = true
          console.log(error)
        })
    },

    showQrSizeModal(e) {
      this.QRSizeModal.title = this.$t('parents.modal_qr.qr_download')
      this.QRSizeModal.value = true
      this.QRSizeModal.parent = e
    },
    showQrSizeModalAll() {
      this.allQrs = true
      this.QRSizeModal.title = this.$t('parents.modal_qr.qr_download')
      this.QRSizeModal.value = true
    },
    clearSearch() {
      this.filters.search = ''
      this.getParentsOfBranch()
    },
    removeFilters() {
      // this.headers[4].filterItems = []
      this.filters.search = ''
      this.filters.studentCounts = []
      this.filters.registry = []
      this.selected = []
      this.getParentsOfBranch()
    },
    handleKeyDown(e) {
      //method to handle the keypress
      if (e.code === 'Escape') {
        this.onCancel()
      }
    },
    onCancel() {
      this.modals.parent = false
      this.QRSizeModal.value = false
      this.toast.edFlag = false
      this.$forceUpdate()
    },
  },
  created() {
    window.addEventListener('keydown', this.handleKeyDown) //will attach the event listener to the whole window when the component is created
  },
  destroyed() {
    window.removeEventListener('keydown', this.handleKeyDown) //will detach the event listener once the component is destroyed
  },
  computed: {
    ...mapGetters(['getBranch', 'getUser', 'getLang']),
    filtersRemove() {
      if (
        this.filters.studentCounts.length ||
        this.filters.search ||
        this.filters.registry.length ||
        this.selected.length
      ) {
        return true
      } else {
        return false
      }
    },
    selectedToSend() {
      return this.selected.filter((p) => !p.pWchanged)
    },
  },
}
</script>

<style>
.expandableContainer {
  border-style: solid;
  border-color: #e6e6e6;
  border-radius: 15px;
  border-width: 2px;
}

.titleSearch .v-input .v-input__slot {
  border-radius: 33px !important;
  margin-bottom: 0;
}

.v-text-field--box .v-input__slot,
.v-text-field--outline .v-input__slot {
  display: flex !important;
  align-items: center !important;
  min-height: auto !important;
}
.fitty {
  display: flex !important;
  align-items: center !important;
  min-height: auto !important;
}
.no-border {
  border: 0;
}

.position-no {
  position: absolute;
  top: 0px;
  right: 0px;
  z-index: -1;
}
.little-green {
  background-color: #e5ecdf !important;
}
.container.select-all-banner {
  background-color: #cecece;
  padding-top: 12px;
  padding-bottom: 12px;
}
.container.select-all-banner a {
  font-weight: bold;
}
</style>

<style scoped>
.sortable_pick {
  cursor: pointer;
}
.main-tool-bar {
  z-index: 1;
}
::v-deep .main-tool-bar .v-toolbar__content {
  height: auto !important;
}

::v-deep .table-full .v-datatable.v-table > tbody {
  max-height: calc(106vh - 426px);
  min-height: calc(106vh - 426px);
  -webkit-max-height: calc(106vh - 426px);
  -webkit-min-height: calc(106vh - 426px);
  white-space: nowrap;
}
::v-deep .table-full.with-select-all-banner .v-datatable.v-table > tbody {
  max-height: calc(100vh - 480px);
  min-height: calc(100vh - 480px);
  white-space: nowrap;
}
</style>
